// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import { Turbo } from "@hotwired/turbo-rails";

Turbo.StreamActions.client_quick_created = function() {
  const input = document.getElementById("client-combobox-input");
  if (input) {
    input.value = this.getAttribute("client_name");
  }

  const value = document.getElementById("client-combobox-hidden-input");
  if (value) {
    value.value = this.getAttribute("client_id");
    value.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const modal = document.getElementById("client-combobox-create-modal");
  if (modal) {
    modal.close();
  }
};